export default __webpack_public_path__ + "static/media/help-rav-qa-3.5680d438.png";